module.exports = __webpack_public_path__ + "static/media/spinner-third.e02914db.svg";